module.exports = __webpack_public_path__ + "img/Logo Kanbanesia.debb116a.png";